import React from 'react';
import { connect } from 'react-redux';
import { ResourcesItem } from 'redux-and-the-rest';
import { Redirect, withRouter } from 'react-router-dom';

import { UserModel } from './models/userModel';
import { ApplicationState } from './redux/types';
import { getUser } from './redux/reducers/userReducer';
import { isRegisteredUser } from './utils/UserUtils';
import { Routes } from './routes';

interface Props extends React.ComponentProps<'div'> {
   user: ResourcesItem<UserModel>;
   location: {
     pathname: string;
     search: string
   }
}

/**
 * Prevents access to a given component or components based on the User role
 */
const RegisteredUserGate = ({
  children,
  user,
  location,
}: Props) => {
  if (!isRegisteredUser(user)) {
    /**
     * if access is blocked as the User isn't loged in, we're returning to the Url
     * the User was attempting to access on Login or Create Account
     */
    const redirectTo = encodeURIComponent(location.pathname.concat(location.search));
    const loginUrl = Routes.Session.New.concat(`?redirectTo=${redirectTo}`);

    // Redirect to login, with return Url
    return <Redirect to={loginUrl} />;
  }

  return (
    <>
      {children}
    </>
  );
};

const mapStateToProps = ({ users }: ApplicationState) => ({
  user: getUser(users),
});

export default withRouter(connect(mapStateToProps)(RegisteredUserGate));
